import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import Ionicon from 'react-ionicons';

const Loader = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.bg};
`;

const TopBar = ({ theme }) => (
  <ThemeProvider theme={theme}>
    <Loader>
      <Ionicon icon="ios-trending-up" fontSize="40px" color={theme.botBar.icon} />
    </Loader>
  </ThemeProvider>
);

export default withTheme(TopBar);



// WEBPACK FOOTER //
// ./src/components/SimpleLoader.js